/**
 * NIBHV
 *
 * This class holds all the necessary js function for the NIBHV module.
 */

class NIBHV {
    initSettings(screen) {
        const elm = jQuery(screen);

        elm.find('.try-to-connect-nibhv').off('click').on('click', () => {
            this.connect(elm);
            return false;
        });
        if (elm.is(':visible')) {
            this.connect(elm);
        }


        elm.off('connected').on('connected', async () => {
            // fetch nibhv coreData
            const settingsData = await jQuery.get('/nibhv/getSettingsData', {
                filters: ['trainers', 'contactUsers']
            });

            const settings = settingsData.settings;

            const trainers = settingsData.trainers;
            const selectedTrainerUid = settings.trainer_uuid;
            const trainerSelect = elm.find('select#nibhv_trainer_uuid');
            trainerSelect.find('option:not(:first)').remove();

            trainers.forEach((trainer) => {
                const option = jQuery('<option></option>');
                option.val(trainer.uuid);
                option.text(trainer.name);
                if (trainer.uuid === selectedTrainerUid) {
                    option.attr('selected', 'selected');
                }
                trainerSelect.append(option);
            });

            const contactUsers = settingsData.contactUsers;
            const selectedContactUserUid = settings.contact_user_uuid;
            const contactSelect = elm.find('select#nibhv_contact_user_uuid');
            contactSelect.find('option:not(:first)').remove();
            contactUsers.forEach((user) => {
                const option = jQuery('<option></option>');
                option.val(user.uuid);
                option.text(user.full_name);
                if (user.uuid === selectedContactUserUid) {
                    option.attr('selected', 'selected');
                }
                contactSelect.append(option);
            });

            // Enable the run button
            const runButton = elm.find('.run-button');
            runButton[0].disabled = false;
            runButton.off('click').on('click', async (e) => {
                e.preventDefault();
                jQuery('body').isLoading();
                await jQuery.post('/nibhv/run');
                jQuery('body').doneLoading();
                squde_reload_for_flashes();
                reload_location_if_needed(false);
                return false;
            });
        });
    }

    async connect(elm) {
        const box = elm.find('.nibhv-connection-flexbox');

        const userName = box.find('#nibhv_username').val();
        const password = box.find('#nibhv_password').val();
        const url = box.find('#nibhv_url').val();

        if (!userName || !password) {
            return;
        }

        box.isLoading();
        const statusCallout = elm.find('.nibhv-status');
        statusCallout.removeClass('success');
        statusCallout.removeClass('alert');
        const statusSpan = statusCallout.find('span');
        await jQuery.get('/nibhv/checkCredentials', {username: userName, password, url}, (data) => {
            const connected = data.connected;
            if (connected) {
                statusCallout.addClass('success');
                statusSpan.text('Verbonden');

                elm.trigger('connected');
            } else {
                statusCallout.addClass('alert');
                statusSpan.text('Niet verbonden');
            }
        });
        box.doneLoading();
    }


    initCourseDetails(screen) {
        const elm = jQuery(screen);

        const fieldsWrapper = elm.find('.nibhv-form');
        const filters = elm.find('.competence-profile-form-filters');
        const competenceProfileTable = elm.find('.competence-profile-table');
        const competenceProfileTableBody = competenceProfileTable.find('tbody');
        const competenceProfileTableSearchInput = competenceProfileTable.find('input[type="search"]');
        const eventTemplatesWrapper = elm.find('.event-templates-wrapper');
        const eventTemplatesTable = eventTemplatesWrapper.find('.event-templates-table');
        const eventTemplatesTableBody = eventTemplatesTable.find('tbody');


        const nibhvSwitch = elm.find('#nibhv-switch');
        nibhvSwitch.off('change').on('change', function() {
            elm.find('.disabled-description').toggle(!this.checked);
            fieldsWrapper.toggle(this.checked);
            if (this.checked) {
                // If the screen got enabled, fetch the data
                // This needs to be in a timeout, because otherwise this won't run after a reload
                requestAnimationFrame(() => filters.trigger('search'));
            }
        }).trigger('change');

        // Trigger search for select changes
        filters.find('select').off('change').on('change', function() {
            filters.trigger('search');
        });
        // Find the competence profile based on the selected filters
        filters.off('search').on('search', async function() {
            if (!elm.is(':visible')) return;
            eventTemplatesWrapper.hide();
            eventTemplatesTableBody.empty();
            competenceProfileTableSearchInput.val('');
            competenceProfileTableBody.empty();

            const type = elm.find('#nibhv_type').val();
            const isRefresher = elm.find('#nibhv_kind').val() === 'refresher';
            const language = elm.find('#nibhv_language').val();
            filters.isLoading();
            const data = await jQuery.get('/nibhv/getCompetenceProfiles', {type, isRefresher, language});
            filters.doneLoading();

            const value = competenceProfileTable.data('competence-profile-uuid');

            data.forEach((profile) => {
                const tr = jQuery('<tr></tr>');
                const div = jQuery('<div></div>');
                div.css({
                    display: 'flex',
                });
                // inputValue is base64 json string
                const inputValue = btoa(encodeURIComponent(JSON.stringify(profile)));
                const inputRadio = jQuery(`<input type="radio" name="nibhv_competence_profile" id="nibhv_competence_profile_${profile.uuid}" value="${inputValue}" style="margin: 0;">`);
                const label = jQuery(`<label for="nibhv_competence_profile_${profile.uuid}">${profile.course_name}</label>`);
                label.css({
                    flex: 1,
                });
                const td = jQuery('<td></td>');
                div.append(inputRadio);
                div.append(label);
                td.append(div);
                tr.append(td);

                // React onChange
                inputRadio.off('change').on('change', async function() {
                    competenceProfileTable.data('data-competence-profile-uuid', profile.uuid);
                    eventTemplatesWrapper.trigger('reload');
                });

                // Set current value
                const checked = value === profile.uuid;
                inputRadio.prop('checked', checked);
                if (checked) {
                    competenceProfileTableBody.prepend(tr);
                    inputRadio.trigger('change');
                } else {
                    competenceProfileTableBody.append(tr);
                }
            });
        });

        // Search profilenames
        let debounceTimer;
        competenceProfileTableSearchInput.off('keyup').on('keyup', function() {
            const value = jQuery(this).val().toLowerCase();

            debounceTimer && debounceTimer.cancel();

            debounceTimer = _.debounce(() => {
                // if items are found, show them on the right position, if they are not found, hide them and append them to the table
                // store the original order of row in the data attribute
                competenceProfileTableBody.find('tr').each(function() {
                    const tr = jQuery(this);
                    const label = tr.find('label').text().toLowerCase();
                    const index = tr.data('index');
                    if (label.indexOf(value) > -1) {
                        tr.show();
                        if (index !== undefined) {
                            competenceProfileTableBody.find('tr').eq(index).before(tr);
                        }
                    } else {
                        tr.hide();
                        if (index === undefined) {
                            tr.data('index', competenceProfileTableBody.find('tr').index(tr));
                        }
                        competenceProfileTableBody.append(tr);
                    }
                });
            }, 300);
            debounceTimer();
        });

        eventTemplatesWrapper.off('reload').on('reload', async function() {
            const competenceProfileUuid = competenceProfileTable.data('data-competence-profile-uuid');
            eventTemplatesWrapper.toggle(!!competenceProfileUuid);
            if (!competenceProfileUuid) return;

            eventTemplatesTableBody.empty();
            eventTemplatesWrapper.isLoading();
            const data = await jQuery.get(`/nibhv/getCompetenceProfileEventTemplates/${competenceProfileUuid}`);
            eventTemplatesWrapper.doneLoading();

            eventTemplatesWrapper.find('.repeat-item').each(function() {
                const componentItem = jQuery(this);
                const componentId = componentItem.data('id');
                const table = componentItem.find('.scrollable-table');
                const tableBody = table.find('tbody');
                const templates = JSON.parse(componentItem.attr('data-event-templates'));
                const index = componentItem.index();

                data.forEach((eventTemplate) => {
                    const tr = jQuery('<tr></tr>');
                    const td = jQuery('<td></td>');
                    const div = jQuery('<div></div>');
                    div.css({
                        display: 'flex',
                    });
                    const componentIdInput = jQuery(`<input type="hidden" name="components[${index}][id]" value="${componentId}">`);
                    // inputValue is base64 json string
                    _.unset(eventTemplate, 'prerequisites');

                    const inputValue = btoa(JSON.stringify(eventTemplate));
                    const input = jQuery(`<input type="checkbox" value="${inputValue}" name="components[${index}][event_templates][]" id="component_${componentId}_event_templates_${eventTemplate.uuid}" style="margin: 0;">`);
                    const label = jQuery(`<label for="component_${componentId}_event_templates_${eventTemplate.uuid}">${eventTemplate.name}</label>`);
                    label.css({
                        flex: 1,
                    });

                    // React onChange
                    input.off('change').on('change', function() {
                        const checked = input.is(':checked');
                        const checkedValue = input.val();
                        const index = templates.indexOf(checkedValue);
                        if (checked && index === -1) {
                            templates.push(checkedValue);
                        } else if (!checked && index !== -1) {
                            templates.splice(index, 1);
                        }
                        componentItem.attr('data-event-templates', JSON.stringify(templates));
                    });

                    // Set current value
                    const checked = templates.indexOf(eventTemplate.uuid) !== -1;
                    input.prop('checked', checked);

                    // Save to dom
                    div.append(input);
                    div.append(label);
                    td.append(componentIdInput);
                    td.append(div);
                    tr.append(td);
                    if (checked) {
                        tableBody.prepend(tr);
                    } else {
                        tableBody.append(tr);
                    }
                });
            });
        }).trigger('reload');
    }

    refresh_nibhv_results(appointmentGroupId) {
        const $ = jQuery.noConflict();
        const url =  `/nibhv/appointmentGroup/${appointmentGroupId}/syncResults`;

        (async () => {
            const body = $('body');
            body.isLoading();
            await $.get(url);
            body.doneLoading();
            reload_location_if_needed(false);
        })();
        return false;
    }
}

const nibhv = new NIBHV();
